/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetAgentGraphPathParams = NonNullable<operations['getAgentGraph']['parameters']['path']>;

export interface Input extends GetAgentGraphPathParams {
  apiVersion?: string;
  header: NonNullable<operations['getAgentGraph']['parameters']['header']>;
}

export async function getAgentGraph(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/agent-graphs/{graphKey}', {
    params: { path, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
